<template>
  <div class="cart-total-price">
    <span class="cart-total-price__title">合計金額</span>
    <span class="cart-total-price__price">{{ stateCartTotalPrice | price }}</span>
    <span class="cart-total-price__unit">円</span>
  </div>
</template>



<script>
import { mapState } from 'vuex'

export default {
  computed: {
    ...mapState({
      stateCartTotalPrice: state => state.cart.totalPrice,
    }),
  },
  filters: {
    price(val) {
      if (!val) return 0

      val = String(val)
      val = val.replace(/,/g, '')
      val = Number(val)
      val = val.toLocaleString()
      val = val.toString()

      return val
    },
  },
}
</script>



<style lang="scss">
.cart-total-price {
  &__title {
    display: inline-block;
    font-size: 12px;
    letter-spacing: 0.05em;
    margin-right: 14px;
  }
  &__price {
    display: inline-block;
    font-family: $serif;
    font-weight: bold;
    font-size: 16px;
    margin-right: 4px;
  }
  &__unit {
    display: inline-block;
    font-family: $serif;
    font-size: 12px;
  }
}
</style>
